import axios from 'axios'
export default class ApiClient {
  constructor (token, baseUrl) {
    this.headers = {
      Authorization: 'Bearer ' + token,
      'content-type': 'application/json'
    }
    this.baseUrl = baseUrl
    this.baseParams = process.env.VUE_APP_ENV === 'development' ? { user: 'shopify:' + process.env.VUE_APP_SHOPIFY_STORE, user_id: 'shopify:' + process.env.VUE_APP_SHOPIFY_STORE } : {}
  }

  async get (endpoint, params) {
    const requestParams = { ...params, ...this.baseParams }
    const headers = this.headers
    try {
      const response = await axios.get(this.baseUrl + endpoint, { headers, params: requestParams })
      return response.data
    } catch (err) {
      console.log('err in backend client get method ===>', err.response.data)
      alert('something went wrong. Please try again later !')
      throw err
    }
  }
}
